import { render, staticRenderFns } from "./ValidationSelect.vue?vue&type=template&id=ec6146c0"
import script from "./ValidationSelect.vue?vue&type=script&lang=js"
export * from "./ValidationSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports